import { Checkbox } from '@material-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';
import KendoDataGridShell from '../../../components/KendoDataGrid/KendoDataGridShell';
import OverflowTooltip from '../../../components/OverflowTooltip';
import { FBProcedureItemConfig } from '../../FBProcedureItem/FBProcedureItem.types';
import { FB } from '../../helpers';
import { CELL_EMPTY_VALUE } from './constants';
import { getMaterialShellColumns } from './shellColumns';

interface ViewProps {
  items?: FBProcedureItemConfig[]
}

const MaterialTitle: React.FC<{ item: FBProcedureItemConfig }> = ({ item }) => {
  const { procedureCatalogState } = FB.useStores();
  const label = useObserver(() => {
    const fieldValue = procedureCatalogState?.getMaterialLabel(item.title) || item.title;
    return item.LHRTparameter ? `${item.id}:${fieldValue}` : fieldValue;
  });

  return (
    <OverflowTooltip title={label} placement="top" interactive arrow deferred>
      {label}
    </OverflowTooltip>
  );
};

const View: React.FC<ViewProps> = ({ items = [] }) => (
  <div data-cy="material-grid">
    <KendoDataGridShell
      columns={getMaterialShellColumns({ isMPIProcedure: true })}
      interactive
      dataCy="mpi-materials-view-table"
    >
      {items.map((item) => (
        <tr key={item.id} data-cy={`alloc-row-${item.id}`}>
          <td data-cy="title-cell">
            <MaterialTitle item={item} />
          </td>
          <td data-cy="LHRTparameter-cell">
            <Checkbox checked={Boolean(item.LHRTparameter)} disabled color="primary" />
          </td>
          <td data-cy="quantity-cell">
            {item.quantity == null ? CELL_EMPTY_VALUE : item.quantity}
          </td>
          <td data-cy="unit-cell">
            <OverflowTooltip
              title={item.unit ?? CELL_EMPTY_VALUE}
              placement="top"
              interactive
              arrow
              deferred
            >
              {item.unit ?? CELL_EMPTY_VALUE}
            </OverflowTooltip>
          </td>
        </tr>
      ))}
    </KendoDataGridShell>
  </div>
);

export default View;
